import React, { useState } from 'react';
import { Button } from '../ui/button';
import { BookOpen, Lightbulb, ChevronRight } from 'lucide-react';

export default function Teaching({ title, content, tip, onAnswer }) {
  const [hasRead, setHasRead] = useState(false);

  const handleContinue = () => {
    setHasRead(true);
    // Teaching bölümü her zaman "doğru" sayılır
    if (onAnswer) {
      onAnswer(true, 1);
    }
  };

  return (
    <div className="w-full max-w-2xl mx-auto">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <div className="p-3 bg-blue-100 rounded-xl">
          <BookOpen className="w-6 h-6 text-blue-600" />
        </div>
        <div>
          <h2 className="text-xl font-bold text-gray-800">{title}</h2>
          <p className="text-sm text-gray-500">Öğrenme bölümü</p>
        </div>
      </div>

      {/* Content */}
      <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 mb-6">
        <div 
          className="prose prose-sm max-w-none text-gray-700"
          dangerouslySetInnerHTML={{ __html: content }}
          style={{
            lineHeight: '1.8'
          }}
        />
      </div>

      {/* Tip Box */}
      {tip && (
        <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 mb-6 flex items-start gap-3">
          <Lightbulb className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" />
          <p className="text-sm text-yellow-800">{tip}</p>
        </div>
      )}

      {/* Continue Button */}
      <Button
        onClick={handleContinue}
        className="w-full py-4 text-lg font-bold bg-emerald-500 hover:bg-emerald-600 rounded-xl"
      >
        Anladım, Devam Et
        <ChevronRight className="w-5 h-5 ml-2" />
      </Button>
    </div>
  );
}
